"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
var NOTIFICATION_PAGE_STATE = {
  initial: 'initial',
  loadingQuickFilters: 'loadingQuickFilters',
  quickFiltersLoaded: 'quickFiltersLoaded',
  loadingNotifications: 'loadingNotifications',
  notificationsLoaded: 'notificationsLoaded',
  notificationsRefreshed: 'notificationsRefreshed',
  errored: 'errored'
};
var _default = NOTIFICATION_PAGE_STATE;
var _default2 = _default;
exports.default = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(NOTIFICATION_PAGE_STATE, "NOTIFICATION_PAGE_STATE", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/common/notification-page-state.js");
  reactHotLoader.register(_default, "default", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/common/notification-page-state.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJOT1RJRklDQVRJT05fUEFHRV9TVEFURSIsImluaXRpYWwiLCJsb2FkaW5nUXVpY2tGaWx0ZXJzIiwicXVpY2tGaWx0ZXJzTG9hZGVkIiwibG9hZGluZ05vdGlmaWNhdGlvbnMiLCJub3RpZmljYXRpb25zTG9hZGVkIiwibm90aWZpY2F0aW9uc1JlZnJlc2hlZCIsImVycm9yZWQiXSwic291cmNlcyI6WyIuLi8uLi9zcmMvY29tbW9uL25vdGlmaWNhdGlvbi1wYWdlLXN0YXRlLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImNvbnN0IE5PVElGSUNBVElPTl9QQUdFX1NUQVRFID0ge1xuXHRpbml0aWFsOiAnaW5pdGlhbCcsXG5cdGxvYWRpbmdRdWlja0ZpbHRlcnM6ICdsb2FkaW5nUXVpY2tGaWx0ZXJzJyxcblx0cXVpY2tGaWx0ZXJzTG9hZGVkOiAncXVpY2tGaWx0ZXJzTG9hZGVkJyxcblx0bG9hZGluZ05vdGlmaWNhdGlvbnM6ICdsb2FkaW5nTm90aWZpY2F0aW9ucycsXG5cdG5vdGlmaWNhdGlvbnNMb2FkZWQ6ICdub3RpZmljYXRpb25zTG9hZGVkJyxcblx0bm90aWZpY2F0aW9uc1JlZnJlc2hlZDogJ25vdGlmaWNhdGlvbnNSZWZyZXNoZWQnLFxuXHRlcnJvcmVkOiAnZXJyb3JlZCcsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBOT1RJRklDQVRJT05fUEFHRV9TVEFURTsiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7QUFBQSxJQUFNQSx1QkFBdUIsR0FBRztFQUMvQkMsT0FBTyxFQUFFLFNBQVM7RUFDbEJDLG1CQUFtQixFQUFFLHFCQUFxQjtFQUMxQ0Msa0JBQWtCLEVBQUUsb0JBQW9CO0VBQ3hDQyxvQkFBb0IsRUFBRSxzQkFBc0I7RUFDNUNDLG1CQUFtQixFQUFFLHFCQUFxQjtFQUMxQ0Msc0JBQXNCLEVBQUUsd0JBQXdCO0VBQ2hEQyxPQUFPLEVBQUU7QUFDVixDQUFDO0FBQUMsZUFFYVAsdUJBQXVCO0FBQUE7QUFBQTtBQUFBO0FBQUE7RUFBQTtFQUFBO0lBQUE7RUFBQTtFQUFBLHdCQVZoQ0EsdUJBQXVCO0VBQUE7QUFBQTtBQUFBO0FBQUE7RUFBQTtFQUFBO0FBQUEifQ==